import type { IFuseOptions } from 'fuse.js';
import type { CommandInternal } from '../../../../common/types/commands/index.tsx';
import { removeShortcutSpecialCharacters } from '../../../../common/utils.tsx';

export const FUSE_SEARCH_OPTIONS: IFuseOptions<CommandInternal> = {
	threshold: 0.3,
	keys: [
		{
			name: 'shortcut',
			getFn: (command) => removeShortcutSpecialCharacters(command.shortcut ?? ''),
			weight: Math.pow(2, 6),
		},
		{ name: 'name', weight: Math.pow(2, 5) },
		{ name: 'searchKeywordsArray', weight: Math.pow(2, 2) },
		{ name: 'sectionName', weight: Math.pow(2, 1) },
	],
	includeScore: true,
	shouldSort: false,
	distance: 1000,
	ignoreFieldNorm: true,
};
